import {
    CommentsAttachment,
    CommentType,
    CreateMessageBody,
    GetMessageParams,
    ReactionOperation,
    ThreadListSort,
    UploadFileType,
} from '../../models/comments'
import { CommentsService } from '../../services/CommentsService'
import {
    // getChildBorderConfig,
    getMessageListFromApi,
} from '../../utils/comments-adapter'
import {
    COMMENTS_REDUCER_NAMESPACE,
    ROOT_PAGE_NUM,
    // Topic,
} from '../reducers/comments'

export const CommentsActionTypes = {
    INIT_TOPIC: 'INIT_TOPIC',
    DELETE_TOPIC: 'DELETE_TOPIC',
    SET_TOTAL_COUNT: 'SET_TOTAL_COUNT',
    SET_MESSAGE_LIST: 'SET_MESSAGE_LIST',
    SET_LOADING: 'SET_COMMENTS_LOADING',
    SET_LOADING_MORE: 'SET_COMMENTS_LOADING_MORE',
    SET_LOADING_MESSAGE: 'SET_COMMENTS_LOADING_MESSAGE',
    SET_PAGE_NUM_MAP: 'SET_PAGE_NUM_MAP',
    RESET_PAGE_NUM_MAP: 'RESET_PAGE_NUM_MAP',
    SET_ATTACHMENT_MAP: 'SET_ATTACHMENT_MAP',
    SET_TYPE: 'SET_TYPE',
    DELETE_REQUEST: 'DELETE_REQUEST',
    DELETE_SUCCESS: 'DELETE_SUCCESS',
    FORUM_FAILURE: 'FORUM_FAILURE',
}

export const setType = (commentType: CommentType) => {
    return {
        type: CommentsActionTypes.SET_TYPE,
        commentType,
    }
}
export const initTopic = (topicId: string) => {
    return {
        type: CommentsActionTypes.INIT_TOPIC,
        topicId,
    }
}
export const deleteTopic = (topicId: string) => {
    return {
        type: CommentsActionTypes.DELETE_TOPIC,
        topicId,
    }
}
export const setLoading = (loading: boolean, topicId: string) => {
    return {
        type: CommentsActionTypes.SET_LOADING,
        payload: { loading, topicId },
    }
}
export const setLoadingMore = (loading: boolean, topicId: string) => {
    return {
        type: CommentsActionTypes.SET_LOADING_MORE,
        payload: { loading, topicId },
    }
}
export const setLoadingMessage = (loading: boolean, topicId: string) => {
    return {
        type: CommentsActionTypes.SET_LOADING_MESSAGE,
        payload: { loading, topicId },
    }
}

export const setTotalCount = (totalCount: number, topicId: string) => {
    return {
        type: CommentsActionTypes.SET_TOTAL_COUNT,
        payload: { totalCount, topicId },
    }
}
export const setPageNumMap = (
    pageNumMap: Record<string, number>,
    topicId: string
) => {
    return {
        type: CommentsActionTypes.SET_PAGE_NUM_MAP,
        payload: { pageNumMap, topicId },
    }
}
export const resetPageNumMap = (
    pageNumMap: Record<string, number>,
    topicId: string
) => {
    return {
        type: CommentsActionTypes.RESET_PAGE_NUM_MAP,
        payload: { pageNumMap, topicId },
    }
}
export const setAttachmentMap = (
    attachmentMap: Record<string, CommentsAttachment[]>,
    topicId: string
) => {
    return {
        type: CommentsActionTypes.SET_ATTACHMENT_MAP,
        payload: { attachmentMap, topicId },
    }
}
export const setMessageList = (messageList: any[], topicId: string) => {
    return {
        type: CommentsActionTypes.SET_MESSAGE_LIST,
        payload: { messageList, topicId },
    }
}
export const deleteSuccess = (successLabel: string) => {
    return {
        type: CommentsActionTypes.DELETE_SUCCESS,
        toastList: [
            {
                text: successLabel,
            },
        ],
    }
}
export const commentsFailure = (error?: any) => {
    return {
        type: CommentsActionTypes.FORUM_FAILURE,
        toastList: [
            {
                text: error,
            },
        ],
    }
}

export const findNode = (nodeIds: string[], nodeList, node?) => {
    const localNodeIds = [...nodeIds]
    if (!localNodeIds.length) {
        return node
    }
    const newNode =
        nodeList[nodeList.findIndex((m) => m.id === localNodeIds[0])]
    localNodeIds.splice(0, 1)
    return findNode(localNodeIds, newNode?.replyList, newNode)
}

export const createMessage = (
    body: CreateMessageBody,
    topicId: string,
    nodeIds: string[],
    messageId?: string
) => {
    return (dispatch, getState) => {
        const id = messageId || topicId
        dispatch(setLoadingMessage(!body.reference.parentId || !!messageId, id))
        const oldMessages = [
            ...getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[id].messageList,
        ]
        let oldMessage = findNode(nodeIds, oldMessages)
        if (!!nodeIds.length) {
            delete oldMessage.showLoadMore
            oldMessage.isLoadMoreLoading = true
            dispatch(setMessageList(oldMessages, id))
        }
        const topic = getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[id]
        let attachmentIds = []
        if (
            !body.reference.parentId ||
            (!!body.reference.parentId && body.reference.parentId === messageId)
        )
            attachmentIds =
                topic?.attachmentMap[ROOT_PAGE_NUM]?.map((a) => a.id) || []
        if (body.reference.parentId && body.reference.parentId !== messageId)
            attachmentIds = oldMessage.uploadList?.map((a) => a.id) || []
        body.attachmentIds = attachmentIds
        CommentsService.CreateMessage(
            body,
            getState()[COMMENTS_REDUCER_NAMESPACE].type
        )
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(setAttachmentMap({ [ROOT_PAGE_NUM]: [] }, id))
                    dispatch(
                        getMessageList(
                            {
                                threadId: body.reference.threadId,
                                topicId: body.reference.topicId,
                                projectId: body.reference.projectId,
                                documentId: body.reference.documentId,
                                parentId: body.reference.parentId,
                                disableListLoading: !body.reference.parentId,
                                isEdit: true,
                                nodeIds,
                                messageId,
                            },
                            !!messageId
                        )
                    )
                } else {
                    commentsFailure(res.data.output.payload.message)
                    dispatch(setLoadingMessage(false, id))
                }
            })
            .catch((error) => {
                dispatch(setLoadingMessage(false, id))
                dispatch(
                    commentsFailure(
                        error.response?.data?.message || error.message
                    )
                )
            })
    }
}
export const editMessage = (
    body: CreateMessageBody,
    id: string,
    nodeIds: string[],
    parentId: string
) => {
    return (dispatch, getState) => {
        const topicId =
            body.reference.topicId ||
            body.reference.documentId ||
            body.reference.parentId
        const messages =
            getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[
                topicId || body.reference.projectId
            ]?.messageList
        const message = findNode(nodeIds, messages)
        message.isLoadEditSave = true
        dispatch(setMessageList(messages, topicId))
        let newNodeIds = [...nodeIds]
        if (newNodeIds.length > 1) {
            newNodeIds.pop()
        }
        CommentsService.EditMessage(
            body,
            id,
            getState()[COMMENTS_REDUCER_NAMESPACE].type
        )
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(
                        getMessageList(
                            {
                                threadId: body.reference.threadId,
                                topicId: body.reference.topicId,
                                projectId: body.reference.projectId,
                                documentId: body.reference.documentId,
                                messageId: topicId,
                                parentId,
                                disableListLoading: true,
                                isEdit: true,
                                nodeIds: newNodeIds,
                            },
                            !!body.reference.parentId
                        )
                    )
                } else {
                    commentsFailure(res.data.output.payload.message)
                }
            })
            .catch((error) => {
                dispatch(
                    commentsFailure(
                        error.response?.data?.message || error.message
                    )
                )
            })
    }
}
export const reactionMessage = (
    body: Partial<CreateMessageBody>,
    id: string,
    topicId: string,
    nodeIds: string[],
    parentId: string,
    reaction?: string
) => {
    return (dispatch, getState) => {
        const messages =
            getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[topicId].messageList
        const message = findNode(nodeIds, messages)
        let reactionOperation = ReactionOperation.ADD
        let newReaction
        if (!!reaction && message.userReaction === reaction)
            reactionOperation = ReactionOperation.REMOVE
        if (
            !!reaction &&
            !!message.userReaction &&
            message.userReaction !== reaction
        ) {
            newReaction = reaction
            reaction = message.userReaction
            reactionOperation = ReactionOperation.REMOVE
        }
        message.isLoadReaction = true
        dispatch(setMessageList(messages, topicId))
        let newNodeIds = [...nodeIds]
        if (newNodeIds.length > 1) {
            newNodeIds.pop()
        }
        let _body = JSON.parse(JSON.stringify(body))
        delete _body.reference.messageId
        CommentsService.ReactionMessage(
            {
                ..._body,
                reaction: reaction || _body.reaction,
                reactionOperation,
            },
            id,
            getState()[COMMENTS_REDUCER_NAMESPACE].type
        )
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    if (newReaction) {
                        dispatch(
                            reactionMessage(
                                {
                                    reference: {
                                        threadId: body.reference.threadId,
                                        topicId: body.reference.topicId,
                                        projectId: body.reference.projectId,
                                        storeIdList: body.reference.storeIdList,
                                        messageId: body.reference.messageId,
                                        documentId: body.reference.documentId,
                                    },
                                    reaction: newReaction,
                                    reactionOperation: ReactionOperation.ADD,
                                },
                                id,
                                topicId,
                                nodeIds,
                                parentId
                            )
                        )
                    } else {
                        dispatch(
                            getMessageList(
                                {
                                    threadId: body.reference.threadId,
                                    topicId: body.reference.topicId,
                                    projectId: body.reference.projectId,
                                    documentId: body.reference.documentId,
                                    messageId: body.reference.messageId,
                                    parentId,
                                    disableListLoading: true,
                                    isEdit: true,
                                    nodeIds: newNodeIds,
                                },
                                !!body.reference.parentId
                            )
                        )
                    }
                } else {
                    commentsFailure(res.data.output.payload.message)
                }
            })
            .catch((error) => {
                dispatch(
                    commentsFailure(
                        error.response?.data?.message || error.message
                    )
                )
            })
    }
}
export const deleteMessage = (
    id: string,
    body: GetMessageParams,
    nodeIds: string[],
    parentId: string,
    messageId?: string
) => {
    return (dispatch, getState) => {
        const topicId =
            body.topicId || body.documentId || messageId || body.projectId
        const oldMessages = [
            ...getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[topicId]
                .messageList,
        ]
        const oldMessage = findNode(nodeIds, oldMessages)
        oldMessage.isLoadMoreLoading = true
        dispatch(setMessageList(oldMessages, topicId))
        let newNodeIds = [...nodeIds]
        if (newNodeIds.length > 1) {
            newNodeIds.pop()
        }
        CommentsService.DeleteMessage(
            id,
            body,
            getState()[COMMENTS_REDUCER_NAMESPACE].type
        )
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(
                        getMessageList(
                            {
                                ...body,
                                isEdit: true,
                                messageId: topicId,
                                nodeIds: newNodeIds,
                                parentId,
                            },
                            !!messageId
                        )
                    )
                } else {
                    commentsFailure(res.data.output.payload.message)
                }
            })
            .catch((error) => {
                dispatch(
                    commentsFailure(
                        error.response?.data?.message || error.message
                    )
                )
            })
    }
}
export const removeFile = (
    fileId: string,
    parentId: string,
    topicId: string,
    nodeIds: string[]
) => {
    return (dispatch, getState) => {
        let fileIndex
        if (!parentId) {
            const newAttachmentMap =
                getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[topicId]
                    .attachmentMap[ROOT_PAGE_NUM] || []
            fileIndex = newAttachmentMap.findIndex((f) => f.id === fileId)
            newAttachmentMap.splice(fileIndex, 1)
            dispatch(setAttachmentMap(newAttachmentMap, topicId))
        } else {
            const oldMessages = [
                ...getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[topicId]
                    .messageList,
            ]
            const oldMessage = findNode(nodeIds, oldMessages)
            fileIndex = oldMessage.uploadList.findIndex((f) => f.id === fileId)
            oldMessage.uploadList.splice(fileIndex, 1)
            dispatch(setMessageList(oldMessages, topicId))
        }
    }
}

const handlerUpload = (
    files: FileList,
    type: UploadFileType,
    getState: any,
    dispatch: any,
    oldMessage: any,
    oldMessages: any,
    topicId: string,
    i: number = 0,
    filesUploaded: any[] = []
) => {
    const file = files[i]
    const reader = new FileReader()
    reader.onload = async (evt) => {
        dispatch(setLoadingMessage(!oldMessage, topicId))
        await CommentsService.UploadFile(
            evt.target.result,
            type,
            file.name,
            file.type,
            getState()[COMMENTS_REDUCER_NAMESPACE].type
        )
            .then((res) => {
                filesUploaded.push({
                    file,
                    name: file.name,
                    id: res.data.id,
                    url: res.data.url,
                })
                if (files.length > i + 1) {
                    handlerUpload(
                        files,
                        type,
                        getState,
                        dispatch,
                        oldMessage,
                        oldMessages,
                        topicId,
                        i + 1,
                        filesUploaded
                    )
                } else {
                    if (res && res.data && !res.data.output) {
                        if (!oldMessage) {
                            dispatch(
                                setAttachmentMap(
                                    {
                                        [ROOT_PAGE_NUM]: [
                                            ...(getState()[
                                                COMMENTS_REDUCER_NAMESPACE
                                            ].topicMap[topicId].attachmentMap[
                                                ROOT_PAGE_NUM
                                            ] || []),
                                            ...filesUploaded,
                                        ],
                                    },
                                    topicId
                                )
                            )
                        } else {
                            oldMessage.uploadList = [
                                ...(oldMessage.uploadList || []),
                                ...filesUploaded,
                            ]
                            dispatch(setMessageList(oldMessages, topicId))
                        }
                    } else {
                        commentsFailure(res.data.output.payload.message)
                    }
                    dispatch(setLoadingMessage(false, topicId))
                    if (oldMessage) {
                        delete oldMessage.isLoading
                        dispatch(setMessageList(oldMessages, topicId))
                    }
                }
            })
            .catch((e) => {
                dispatch(
                    commentsFailure(e.response?.data?.message || e.message)
                )
                dispatch(setLoadingMessage(false, topicId))
                if (oldMessage) {
                    delete oldMessage.isLoading
                    dispatch(setMessageList(oldMessages, topicId))
                }
            })
    }
    reader.readAsDataURL(file)
}

export const uploadFile = (
    files: FileList,
    type: UploadFileType,
    parentId: string,
    topicId: string,
    nodeIds: string[]
) => {
    return (dispatch, getState) => {
        let oldMessage, oldMessages
        if (parentId) {
            oldMessages = [
                ...getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[topicId]
                    .messageList,
            ]
            oldMessage = findNode(nodeIds, oldMessages)
            oldMessage.isLoading = true
            dispatch(setMessageList(oldMessages, topicId))
        }
        handlerUpload(
            files,
            type,
            getState,
            dispatch,
            oldMessage,
            oldMessages,
            topicId
        )
    }
}
export const loadMore = (
    parentId: string,
    partialBody: GetMessageListActionParams,
    topicId: string,
    nodeIds: string[],
    isDetail?: boolean
) => {
    return (dispatch, getState) => {
        if (!!parentId) {
            dispatch(
                setPageNumMap(
                    {
                        [parentId]:
                            (getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[
                                topicId
                            ].pageNumMap[parentId] || 0) + 1,
                    },
                    topicId
                )
            )
            dispatch(
                getMessageList({ ...partialBody, parentId, nodeIds }, isDetail)
            )
            return
        }
        dispatch(setLoadingMore(true, topicId))
        dispatch(
            setPageNumMap(
                {
                    [ROOT_PAGE_NUM]:
                        getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[topicId]
                            .pageNumMap[ROOT_PAGE_NUM] + 1,
                },
                topicId
            )
        )
    }
}
export interface GetMessageListActionParams {
    threadId?: string
    topicId?: string
    projectId?: string
    storeIdList?: string[]
    documentId?: string
    isRootLoading?: boolean
    disableListLoading?: boolean
    isEdit?: boolean
    parentId?: string
    nodeIds?: string[]
    messageId?: string
}
export const getMessageList = (
    {
        threadId,
        topicId,
        projectId,
        documentId,
        isRootLoading,
        disableListLoading,
        isEdit,
        parentId,
        messageId,
        nodeIds,
    }: GetMessageListActionParams,
    isDetail?: boolean
) => {
    const id = topicId || messageId || documentId || projectId

    return (dispatch, getState) => {
        if (isEdit) {
            dispatch(
                resetPageNumMap(
                    {
                        [ROOT_PAGE_NUM]: 1,
                    },
                    id
                )
            )
        }
        let messageList =
            getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[id]?.messageList
        const oldMessages = messageList ? [...messageList] : []
        let oldMessage: any = {}
        if (!!parentId) {
            oldMessage = findNode(nodeIds, oldMessages)
        }
        if (!disableListLoading) {
            if (!isRootLoading && !!oldMessage && oldMessages.length) {
                delete oldMessage.showLoadMore
                oldMessage.isLoadMoreLoading = true
                dispatch(setMessageList(oldMessages, id))
            }
            dispatch(setLoading(isRootLoading, id))
        }
        const pageNumMap =
            getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[id]?.pageNumMap
        if (!!parentId && !pageNumMap[parentId]) {
            dispatch(
                setPageNumMap(
                    {
                        [parentId]: 1,
                    },
                    id
                )
            )
        }
        let parentIdParam = messageId
        if (parentId && parentId !== messageId) {
            parentIdParam = parentId
        }
        CommentsService.GetMessageList(
            {
                pageSize: 5,
                pageNum:
                    getState()[COMMENTS_REDUCER_NAMESPACE].topicMap[id]
                        .pageNumMap[parentId || ROOT_PAGE_NUM],
                threadId,
                topicId,
                projectId,
                documentId,
                parentId: parentIdParam,
                sortAction: ThreadListSort.ASC,
                isDetail: isDetail || !!messageId,
            },
            getState()[COMMENTS_REDUCER_NAMESPACE].type
        )
            .then((res) => {
                // if (!!parentId && !!oldMessage) {
                if (!!parentId && !!oldMessage && parentId !== messageId) {
                    oldMessage.replyList = getMessageListFromApi(
                        isEdit
                            ? res.data.data
                            : [...oldMessage.replyList, ...res.data.data],
                        getState().userReducer.user.user_id,
                        oldMessage.nodeIds
                    )
                    oldMessage.showLoadMore =
                        oldMessage.replyList?.length < res.data.totalRecords
                    delete oldMessage.isLoadMoreLoading
                    delete oldMessage.isLoadReaction
                    oldMessage.uploadList = []
                    oldMessage.hasChildBorderTop =
                        oldMessage.replyList?.length > 0 &&
                        oldMessage.nodeIds.length === 1
                    oldMessage.hasChildBorderBottom =
                        oldMessage.nodeIds.length === 2
                    oldMessage.hasChildBorderBottomSecond =
                        oldMessage.replyList?.length > 0 &&
                        oldMessage.nodeIds.length === 2
                    oldMessage.hasThirdChildBorderBottom =
                        oldMessage.nodeIds.length === 3
                    dispatch(setMessageList(oldMessages, id))
                    return
                }
                dispatch(
                    setMessageList(
                        getMessageListFromApi(
                            isEdit
                                ? res.data.data
                                : [...oldMessages, ...res.data.data],
                            getState().userReducer.user.user_id
                        ),
                        id
                    )
                )
                dispatch(setTotalCount(res.data.totalRecords, id))
            })
            .catch((e) => {
                dispatch(
                    commentsFailure(e.response?.data?.message || e.message)
                )
            })
            .finally(() => {
                dispatch(setLoading(false, id))
                dispatch(setLoadingMessage(false, id))
                dispatch(setLoadingMore(false, id))
            })
    }
}
